module.exports = __webpack_public_path__ + "img/protekt-logo-slim-transparent.19290814.png";